import { useRichTextEditorContext } from "@mantine/tiptap";

const LineHeightIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 15 15"
        {...props}
    >
        <path
            fill="#000"
            fillRule="evenodd"
            d="M3.782 2.217a.4.4 0 0 0-.565 0l-2 2a.4.4 0 0 0 .565.566L3.1 3.466v8.068l-1.317-1.317a.4.4 0 0 0-.565.566l2 2a.4.4 0 0 0 .565 0l2-2a.4.4 0 0 0-.565-.566l-1.318 1.317V3.466l1.318 1.317a.4.4 0 0 0 .565-.566l-2-2ZM8.5 4a.5.5 0 1 0 0 1h6a.5.5 0 0 0 0-1h-6ZM8 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 1 0 0 1h6a.5.5 0 0 0 0-1h-6Z"
            clipRule="evenodd"
        />
    </svg>
);

export const LineHeightSelect: React.FC = () => {
    const { editor } = useRichTextEditorContext();

    if (!editor) {
        return null;
    }

    return (
        <div className="flex items-center gap-2" title="Adjust line spacing">
            <LineHeightIcon className="w-4 h-4" />
            <select
                onChange={(e) => {
                    const value = e.target.value;
                    if (value === "unset") {
                        editor?.chain().focus().unsetLineHeight().run();
                    } else {
                        editor?.chain().focus().setLineHeight(value).run();
                    }
                }}
                value={editor?.getAttributes("textStyle").lineHeight || "unset"}
                data-test-id="line-height-select"
                className="line-height-select"
            >
                <option value="unset">1.5</option>
                <option value="2">2</option>
                <option value="2.5">2.5</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </select>
        </div>
    );
};
